
export const artistRegEx = new RegExp('^(https://music.apple.com/)')